export interface ProductTeaserLike {
  readonly displayPosition: number;
  readonly children: unknown;
}

export interface ProductTeaserRenderPlanEntry<PT extends ProductTeaserLike> {
  readonly teaser: PT;
  readonly teaserIndex: number;
  readonly fromIndex: number;
  readonly toIndex: number;
}

export interface ProductTeaserRenderPlan<PT extends ProductTeaserLike> {
  readonly entries: ReadonlyArray<ProductTeaserRenderPlanEntry<PT>>;
  readonly consumedProductCount: number;
}

export function buildProductTeaserRenderPlan<PT extends ProductTeaserLike>(
  productTeaser: ReadonlyArray<PT>,
  productsLength: number,
  editorMode: boolean
): ProductTeaserRenderPlan<PT> {
  const entries: Array<ProductTeaserRenderPlanEntry<PT>> = [];
  let currentIndex = 0;

  productTeaser.forEach((teaser, teaserIndex) => {
    if (!editorMode && isTeaserChildrenEmpty(teaser.children)) {
      return;
    }

    const nextIndex = currentIndex + teaser.displayPosition;
    if (nextIndex <= productsLength) {
      entries.push({
        teaser,
        teaserIndex,
        fromIndex: currentIndex,
        toIndex: nextIndex
      });
      currentIndex = nextIndex;
    }
  });

  return {
    entries,
    consumedProductCount: currentIndex
  };
}

function isTeaserChildrenEmpty(children: unknown): boolean {
  return !children || (Array.isArray(children) && children.length === 0);
}
